// Beheer van klant-afkortingen: lange bedrijfsnamen ("Omgevingsdienst Midden-
// en West-Brabant") krijgen een korte weergavenaam ("OMWB") in Dagstart en
// de capaciteitsschermen. Eén regel per koppeling: volledige naam = afkorting.
import { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, TextField, Typography } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import { bewaarKlantAfkortingen, haalKlantAfkortingen } from '../../../utils/klantAfkortingen';

export default function KlantAfkortingen() {
  const { instance } = useMsal();
  const [tekst, setTekst] = useState('');
  const [laden, setLaden] = useState(true);
  const [bezig, setBezig] = useState(false);
  const [melding, setMelding] = useState(null);

  useEffect(() => {
    haalKlantAfkortingen()
      .then((map) => setTekst(Object.entries(map).map(([naam, afk]) => `${naam} = ${afk}`).join('\n')))
      .finally(() => setLaden(false));
  }, []);

  const opslaan = async () => {
    setBezig(true); setMelding(null);
    try {
      const map = {};
      tekst.split('\n').forEach((regel) => {
        const i = regel.indexOf('=');
        if (i < 1) return;
        const naam = regel.slice(0, i).trim();
        const afk = regel.slice(i + 1).trim();
        if (naam && afk) map[naam] = afk;
      });
      await bewaarKlantAfkortingen(map, instance.getActiveAccount()?.username || '');
      setMelding({ type: 'success', tekst: `${Object.keys(map).length} afkortingen opgeslagen — direct actief in Dagstart en capaciteit.` });
    } catch (e) {
      setMelding({ type: 'error', tekst: e.message });
    } finally { setBezig(false); }
  };

  return (
    <Box sx={{ maxWidth: 720 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Eén koppeling per regel, als <b>volledige klantnaam = afkorting</b>. De volledige naam moet
        exact overeenkomen met hoe hij in Airtable staat. Voorbeeld:
      </Typography>
      <Box component="pre" sx={{ bgcolor: '#f8fafc', p: 1.5, borderRadius: 1.5, fontSize: 12.5, mb: 1.5 }}>
        {'Omgevingsdienst Midden- en West-Brabant = OMWB\nKiwa Nederland B.V. = KIWA'}
      </Box>
      {laden ? <CircularProgress size={22} /> : (
        <TextField fullWidth multiline minRows={8} maxRows={24} value={tekst}
          onChange={(e) => setTekst(e.target.value)} placeholder="Volledige naam = AFK" />
      )}
      {melding && <Alert severity={melding.type} sx={{ mt: 1.5 }}>{melding.tekst}</Alert>}
      <Button variant="contained" onClick={opslaan} disabled={bezig || laden}
        startIcon={bezig ? <CircularProgress size={14} color="inherit" /> : null}
        sx={{ mt: 1.5, textTransform: 'none', fontWeight: 700 }}>
        Opslaan
      </Button>
    </Box>
  );
}
